import React from 'react';
import { useFormContext, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormComponent, FormComponentProps } from '..';
import FormField from '../../common/form-field';
import css from './action.module.css';
import formFieldCss from '../../common/form-field.module.css';

export default function Action(
  text: string,
  callback: (form: UseFormReturn) => void,
  horizontal?: boolean,
  clssName?: string
): FormComponent {
  return ({ ...rest }) => (
    <ActionComponent
      text={text}
      callback={callback}
      {...rest}
      horizontal={horizontal}
      className={clssName}
    />
  );
}

export function ActionComponent({
  text,
  callback,
  horizontal = false,
  className = null,
}: FormComponentProps & {
  text: string;
  callback: (form: UseFormReturn) => void;
  horizontal?: boolean;
}) {
  const { t } = useTranslation();
  const form = useFormContext();

  return (
    <FormField
      className={
        formFieldCss[className]
          ? formFieldCss[className]
          : formFieldCss['with-action']
      }
      horizontal={horizontal}
    >
      <div className={css['action-container']} onClick={() => callback(form)}>
        {t(text)}
      </div>
    </FormField>
  );
}
